// viewport sizes
export const WIDTH_SM = 640;
export const WIDTH_MD = 768;
export const WIDTH_LG = 1024;
export const WIDTH_XL = 1280;
export const WIDTH_2XL = 1536;